import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheBorder} from "../../TheBorder";
import {TheBorderGameAssets} from "../../TheBorderGameAssets";
import {TheBorderGameMode} from "../../server/TheBorderGameMode";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TheBorderSound} from "../../sound/TheBorderSound";
import {gsap} from "gsap";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";

/**
 * Created by Jerker Nord on 2022-06-30.
 */

export class TheBorderSuperFSIntroView extends PIXI.Container implements StageLayer {

    public numOfFSWonText: PIXI.Text;
    protected _superFSIntroBGImage: PIXI.Sprite;
    protected _button: ContinueButton;
    protected _clickCallback: Function;
    protected _background: PIXI.Sprite;
    protected _spinsAndTextContainer: PIXI.Container;
    private _congratulationText: PIXI.Text;
    private _youWonCoyoteSpinText: PIXI.Text;
    private _xClusterMultiplierText: PIXI.Text;
    private _specialMultiplierText: PIXI.Text;
    private _moreBonusSymText: PIXI.Text;
    private _winCluster: PIXI.Text;
    private _stickyMultiplier: PIXI.Text;
    private _youWonSpinsContainer: PIXI.Container;
    private _shieldContainer: PIXI.Container;
    private _shield: PIXI.Sprite;
    private _xBombContainer: PIXI.Container;
    private _xBomb: PIXI.Sprite;
    private _xWayContainer: PIXI.Container;
    private _xWay: PIXI.Sprite;
    private _cayoteSign: PIXI.Sprite;
    private _topDirt:PIXI.Sprite;

    constructor() {
        super();
        this.name = "TheBorderSuperFSIntroView";
        this.init();
    }

    private init(): void {
        this.visible = false;

        this._background = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._background.tint = 0x000000;
        this._background.alpha = 0;
        this.addChild(this._background);

        this._youWonSpinsContainer = new PIXI.Container();

        this._superFSIntroBGImage = new PIXI.Sprite(TheBorder.assetLoader.getTextures(TheBorderGameAssets.INTRO_BACKGROUND)[0]);
        this._superFSIntroBGImage.anchor.set(0.5, 0.5);
        this._superFSIntroBGImage.position.set(606, 290);
        this._superFSIntroBGImage.alpha = 0;
        this.addChild(this._superFSIntroBGImage);

        this._cayoteSign = new PIXI.Sprite(TheBorder.assetLoader.getTextures(TheBorderGameAssets.INTRO_CAYOTE)[0]);
        this._cayoteSign.alpha = 0;
        this.addChild(this._cayoteSign);

        this._spinsAndTextContainer = new PIXI.Container();
        this._spinsAndTextContainer.position.set(0, 84);
        this.addChild(this._spinsAndTextContainer);

        this._congratulationText = new PIXI.Text(TheBorder.apiPlugin.translations.translate("CONGRATULATIONS!"), new PIXI.TextStyle({
            fill: "#000000",
            fontFamily: OpenSans.FAMILY,
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 48,
        })); //width 712
        this.numOfFSWonText = new PIXI.Text("10", new PIXI.TextStyle({
            fill: "#000000",
            fontFamily: OpenSans.FAMILY,
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 36,
        }));

        this._youWonCoyoteSpinText = new PIXI.Text(TheBorder.apiPlugin.translations.translate("YOU WON") + " COYOTE SPINS", new PIXI.TextStyle({
            fill: "#ffffff",
            fontFamily: OpenSans.FAMILY,
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 32,
        }));//width 470;

        this._xClusterMultiplierText = new PIXI.Text(TheBorder.apiPlugin.translations.translate("xCLUSTER MULTIPLIER"), new PIXI.TextStyle({
            fill: "#ffffff",
            fontFamily: OpenSans.FAMILY,
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 24,
        })); // width 700

        this._specialMultiplierText = new PIXI.Text(TheBorder.apiPlugin.translations.translate("SPECIAL MULTIPLIER"), new PIXI.TextStyle({
            fill: "#ffffff",
            fontFamily: OpenSans.FAMILY,
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 24,
        })); //width 300

        this._winCluster = new PIXI.Text(TheBorder.apiPlugin.translations.translate("EVERYWHERE IN WIN CLUSTER"), new PIXI.TextStyle({
            fill: "#ffffff",
            fontFamily: OpenSans.FAMILY,
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 24,
        })); //width 300

        this._stickyMultiplier = new PIXI.Text(TheBorder.apiPlugin.translations.translate("STICKY MULTIPLIER"), new PIXI.TextStyle({
            fill: "#ffffff",
            fontFamily: OpenSans.FAMILY,
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 24,
        })); // width 700

        this._moreBonusSymText = new PIXI.Text(TheBorder.apiPlugin.translations.translate("MORE SCATTER SYMBOLS AWARDS EXTRA SPINS"), new PIXI.TextStyle({
            fill: "#ffffff",
            fontFamily: OpenSans.FAMILY,
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 24,
        })); // width 700

        this._shield = new PIXI.Sprite(TheBorder.assetLoader.getTextures(TheBorderGameAssets.INTRO_SHIELD)[0]);
        this._shield.anchor.set(0, 0.5);
        this._shieldContainer = new PIXI.Container();

        this._shieldContainer.addChild(
            this._shield,
            this.numOfFSWonText
        )

        this._youWonSpinsContainer.addChild(
            this._youWonCoyoteSpinText,
            this._shieldContainer
        )

        this._xBomb = new PIXI.Sprite(TheBorder.assetLoader.getTextures(TheBorderGameAssets.INTRO_XBOMB)[0]);
        this._xBomb.anchor.set(0, 0.5);
        this._xBombContainer = new PIXI.Container();
        this._xBombContainer.addChild(
            this._xBomb,
            this._specialMultiplierText
        )

        this._xWay = new PIXI.Sprite(TheBorder.assetLoader.getTextures(TheBorderGameAssets.INTRO_XWAY)[0]);
        this._xWay.anchor.set(0, 0.5);
        this._xWayContainer = new PIXI.Container();
        this._xWayContainer.addChild(
            this._xWay,
            this._winCluster
        )

        this._spinsAndTextContainer.addChild(
            this._congratulationText,
            this._youWonSpinsContainer,
            this._xClusterMultiplierText,
            this._xBombContainer,
            this._xWayContainer,
            this._stickyMultiplier,
            this._moreBonusSymText
        );

        this._congratulationText.anchor.set(0, 0.5);
        this._youWonCoyoteSpinText.anchor.set(0, 0.5);
        this.numOfFSWonText.anchor.set(0.5, 0.5);
        this._xClusterMultiplierText.anchor.set(0.5, 0.5);
        this._specialMultiplierText.anchor.set(0, 0.5);
        this._winCluster.anchor.set(0, 0.5);
        this._stickyMultiplier.anchor.set(0.5, 0.5);
        this._moreBonusSymText.anchor.set(0.5, 0.5);

        TheBorderSuperFSIntroView.adjustFontSize(this._congratulationText, 520);
        TheBorderSuperFSIntroView.adjustFontSize(this._youWonCoyoteSpinText, 580);
        TheBorderSuperFSIntroView.adjustFontSize(this._xClusterMultiplierText, 680);
        TheBorderSuperFSIntroView.adjustFontSize(this._specialMultiplierText, 580);
        TheBorderSuperFSIntroView.adjustFontSize(this._winCluster, 570);
        TheBorderSuperFSIntroView.adjustFontSize(this._stickyMultiplier, 680);
        TheBorderSuperFSIntroView.adjustFontSize(this._moreBonusSymText, 600);

        if (this._congratulationText.width > 400) {
            this._congratulationText.position.set(160, 60);
        } else {
            this._congratulationText.position.set(360, 60);
            this._congratulationText.anchor.x = 0.5;
        }

        this._cayoteSign.position.set(49, 93);
        this._xClusterMultiplierText.position.set(360, 190);
        this._specialMultiplierText.position.x = this._xBomb.position.x + this._xBomb.width;
        this._xBombContainer.position.set(360 - (this._xBombContainer.width / 2), 240);
        this._winCluster.position.x = this._xWay.position.x + this._xWay.width;
        this._xWayContainer.position.set(360 - (this._xWayContainer.width / 2), 300);
        this._stickyMultiplier.position.set(360, 340);
        this._moreBonusSymText.position.set(360, 380);
        this._shieldContainer.position.set(this._youWonCoyoteSpinText.position.x + this._youWonCoyoteSpinText.width + 12, this._youWonCoyoteSpinText.y);
        this.numOfFSWonText.position.set(35, -3);
        this._youWonSpinsContainer.position.set(360 - (this._youWonSpinsContainer.width / 2), 138);

        this._spinsAndTextContainer.alpha = 0;
        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick());
        this._button.pivot.set(this._button.width * 0.5, this._button.height * 0.5);
        this._button.enable(false)
        this._button.alpha = 0;
        this.addChild(this._button);

        if (TheBorder.model.isRestore && (TheBorder.model.data.mode === TheBorderGameMode.SUPER_FREESPIN || TheBorder.model.data.mode === TheBorderGameMode.SUPER_FREESPIN_AVALANCHE)) {
            TheBorder.keypadPlugin.setZeroBetSpinCounter(Math.max(TheBorder.model.freespinsLeft, 0));
        }

        this._topDirt = new PIXI.Sprite(TheBorder.assetLoader.getTextures(TheBorderGameAssets.INTRO_TOP_DIRT)[0]);
        this._topDirt.anchor.set(0.5, 0.5);
        this._topDirt.position.set(350, 290);
        this._topDirt.blendMode = PIXI.BLEND_MODES.MULTIPLY;
        this._topDirt.alpha = 0;
        this.addChild(this._topDirt);

        this.onResize();
    }

    private static adjustFontSize(textObj: PIXI.Text, width: number): void {
        while (textObj.width > width) {
            textObj.style.fontSize--;
            textObj.updateTransform();
        }
    }

    public onResize(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        this._background.width = NolimitApplication.screenBounds.width;
        this._background.height = NolimitApplication.screenBounds.height;
        this._background.x = NolimitApplication.screenBounds.left;
        this._background.y = NolimitApplication.screenBounds.top;

        //Copied from Launcher/GameIntroView, so we get consistent placement of buttons
        if (NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom - 80);
        }
    }

    public showSuperFSIntro(callback: Function, isUpgrade: boolean): gsap.core.Timeline {
        let startDelay: number = 1;
        if (TheBorder.model.isRestore) {
            startDelay = 0.2;
        }

        if (isUpgrade && !TheBorder.model.isRestore) {
            TheBorder.model.evaluatedArea.forEach((reels: string[], reelId: number) => {
                TheBorder.model.scatterOnReelOnFSTriggered[reelId] = TheBorder.model.scatterOnReelOnFSTriggered[reelId] || (reels.indexOf("BN") > -1 || reels.indexOf("BN_H") > -1);
            });
        }
        this._moreBonusSymText.visible = TheBorder.model.scatterOnReelOnFSTriggered.some((value: boolean) => !value);
        const showSuperFSIntroTL: gsap.core.Timeline = new gsap.core.Timeline({delay: startDelay});

        // #324
        showSuperFSIntroTL.add(TheBorder.scatterSymbols.animateAllForWin());

        showSuperFSIntroTL.add(() => {
            this._clickCallback = callback;
            this._background.alpha = 0;
            this.numOfFSWonText.text = TheBorder.model.data.freespinsLeft.toString();
            this.visible = true;
        });
        showSuperFSIntroTL.add([
            gsap.to(this._background, {duration: 0.4, alpha: 0.7}),
            gsap.to(this._superFSIntroBGImage, {duration: 0.8, alpha: 1}),
            gsap.to(this._topDirt, {duration: 0.8, alpha: 1}),
            gsap.to(this._cayoteSign, {duration: 0.8, alpha: 1}),
            gsap.to(this._spinsAndTextContainer, {duration: 0.8, alpha: 1}),
            new gsap.core.Timeline({delay: 0.279}).add(() => {
                TheBorder.soundPlayer.switchMusic(TheBorderSound.SUPER_FS_INTRO_MUSIC_NAME, {
                    name: "", to: 0, duration: 200
                });
            }),
            () => {
                gsap.to(this._button, {duration: 0.4, alpha: 1});
                if (!isUpgrade) {
                    //gsap.to(this._button, {duration: 0.4, alpha: 1});
                } else {
                    TheBorder.keypadPlugin.setZeroBetSpinCounter(TheBorder.model.freespinsLeft);
                }
            }
        ]);
        showSuperFSIntroTL.add(() => {
            TheBorder.scatterSymbols.turnOffAllScatterSymbols();
            TheBorder.xNudgeSymbols.turnOffAllXNudgeSymbols();
            TheBorder.xSplitSymbols.turnOffAllXSplitSymbols();
            TheBorder.xWaysSymbols.turnOffAllXWaysSymbols();
            TheBorder.xBombSymbols.turnOffAllXBombSymbols();

            this._button.enable(true);
            if (!isUpgrade) {
                //this._button.enable(true);
            }
        });

        return showSuperFSIntroTL;
    }

    protected onButtonClick(): void {
        this._button.enable(false);
        TheBorder.xRipButton.hide();
        const hideSuperFSIntroTL: gsap.core.Timeline = new gsap.core.Timeline();
        hideSuperFSIntroTL.add(() => {
            if (TheBorder.model.isRestore) {
                TheBorder.keypadPlugin.setZeroBetSpinCounter(Math.max(TheBorder.model.data.freespinsLeft, 0));
            } else {
                TheBorder.keypadPlugin.setZeroBetSpinCounter(TheBorder.model.freespinsLeft);
            }
        });
        hideSuperFSIntroTL.add([
            //1.248
            new gsap.core.Timeline().add(() => {
                TheBorder.soundPlayer.switchMusic(TheBorder.model.data.nextMode, {
                    name: "", to: 0, duration: 200
                });
            }),
            gsap.to(this._button, {duration: 0.1, alpha: 0}),
            gsap.to(this._superFSIntroBGImage, {duration: 0.2, alpha: 0}),
            gsap.to(this._topDirt, {duration: 0.2, alpha: 0}),
            gsap.to(this._cayoteSign, {duration: 0.2, alpha: 0}),
            gsap.to(this._background, {duration: 0.2, alpha: 0}),
            gsap.to(this._spinsAndTextContainer, {duration: 0.2, alpha: 0}),
            TheBorder.keypadPlugin.show(),
            () => {
                TheBorder.soundPlayer.playSound(TheBorderSound.FS_CONTINUE_START); //#193
                TheBorder.soundPlayer.playSound(TheBorderSound.FS_SWEEP);
            },
            TheBorder.introPanView.getCayotePanAnimation().restart(),
            () => TheBorder.allReelsView.hideAllReelsUntilAllIn()
        ]);
        hideSuperFSIntroTL.add(() => TheBorder.winMultiplierView.activateSFSWinMultiplier());
        hideSuperFSIntroTL.add(() => TheBorder.backgroundElements.setMode(TheBorderGameMode.SUPER_FREESPIN));
        hideSuperFSIntroTL.add(() => {
            this.visible = false;
            TheBorder.winMultiplierView.setWinMultiplier(TheBorder.model.currentMultiplier);
            this._clickCallback();
        }, "+=0.2");
        hideSuperFSIntroTL.add(() => {
        });
    }
}